import { get } from "lodash";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useQuery } from "urql";
import { useAppSelector } from "../../app/hooks";
import { Card } from "../../components/Layout/Card";
import { CardContent } from "../../components/Layout/CardContent";
import { CardTitle } from "../../components/Layout/CardTitle";
import { getAuthUserInfo } from "../../features/userLogin/userLoginSlice";
import { UserSidebar } from "./UserSidebar";
import { AvoRedApp } from "../../components/Layout/AvoRedApp";

export interface Address {
  id: string;
  type: string;
  address1: string;
  address2: string;
  first_name: string;
  last_name: string;
  phone: string;
  company_name: string;
  city: string;
  state: string;
  country_id: string;
  postcode: string;
}

export const UserAddresses = () => {
  const currentUserInfo = useAppSelector(getAuthUserInfo);

  const CustomerBranchesQuery = `
      query CustomerBranchesQuery{
          customerQuery {
              branches {
                  id
                  name
                  address
              }
          }
      }
    `;
  const [{ fetching, data }] = useQuery({ query: CustomerBranchesQuery });

  return (
    <AvoRedApp>
      <header className="bg-white shadow">
        <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">
            User Addresses
          </h1>
        </div>
      </header>
      <main>
        <div className="mx-auto max-w-7xl py-6 sm:px-6 lg:px-8">
          <div className="px-4 py-6 sm:px-0">
            <div className="flex w-full">
              <div className="w-64 border ">
                <UserSidebar user={currentUserInfo} />
              </div>
              <div className="flex-1 ml-3">
                {fetching === true ? (
                  <p>Loading</p>
                ) : (
                  <>
                    <Card>
                      <CardTitle>
                        <div className="font-semibold">
                          <FormattedMessage id="user_addresses" />
                        </div>
                      </CardTitle>
                      <CardContent>
                        {get(data, "customerQuery.branches", []).map((branch: any) => {
                          return (
                            <div className="mt-5" key={branch.id}>
                              <Card>
                                <CardTitle>
                                  <div className="font-semibold">
                                    {branch.name}
                                  </div>
                                </CardTitle>
                                <CardContent>
                                  <div className="overflow-hidden bg-white shadow sm:rounded-lg">
                                    <div className="px-4 py-5 sm:px-6">
                                      <h3 className="text-lg font-medium leading-6 text-gray-900">
                                          {branch.name}
                                      </h3>
                                      
                                    </div>
                                    <div className="border-t border-gray-200">
                                        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                          <div className="text-sm font-medium text-gray-500">
                                              Address
                                          </div>
                                          <div className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                                              {branch.address}
                                          </div>
                                        </div>
                                    </div>
                                  </div>
                                </CardContent>
                              </Card>
                            </div>
                          );
                        })}
                      </CardContent>
                    </Card>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </AvoRedApp>
  );
};
